var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-disclosure-dropdown-item',{attrs:{"item":_vm.confidentialItem,"data-testid":"confidentiality-toggle-action"},on:{"action":_vm.handleToggleWorkItemConfidentiality}})
}
var staticRenderFns = []

export { render, staticRenderFns }